<template>
    <div>
        <div class="md-layout">
            <div class="md-layout-item md-subheader">
                {{ $tc('phrases.cashTransaction') }}
            </div>
            <div class="md-layout-item md-subheader n-font">
                <img v-if="isAgent" class="logo" alt="logo" :src="agentLogo" style="max-height: 35px;"/>
                <span v-else>{{ $tc('words.admin') }}</span>
            </div>
        </div>
        <hr class="hr-d">
        <div class="md-layout">
            <div class="md-layout-item md-subheader">
                {{ $tc('phrases.collectedBy') }}
            </div>
            <div class="md-layout-item md-subheader n-font">
                {{ isAgent ? $tc('words.agent') : $tc('words.admin') }}
            </div>
        </div>
        <hr class="hr-d">
        <div class="md-layout">
            <div class="md-layout-item md-subheader">
                {{ $tc('words.name') }}
            </div>
            <div class="md-layout-item md-subheader n-font">
                {{ collector.name || '-' }}
            </div>
        </div>
        <hr class="hr-d">
        <div class="md-layout">
            <div class="md-layout-item md-subheader">
                {{ $tc('words.phone') }}
            </div>
            <div class="md-layout-item md-subheader n-font">
                {{ collector.phone || '-' }}
            </div>
        </div>
        <hr class="hr-d">
        <div class="md-layout">
            <div class="md-layout-item md-subheader">
                {{ $tc('words.email') }}
            </div>
            <div class="md-layout-item md-subheader n-font">
                {{ collector.email || '-' }}
            </div>
        </div>
        <template v-if="isAgent">
            <hr class="hr-d">
            <div class="md-layout">
                <div class="md-layout-item md-subheader">
                    {{ $tc('words.miniGrid') }}
                </div>
                <div class="md-layout-item md-subheader n-font">
                    {{ collector.miniGrid || '-' }}
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { AgentService } from '@/services/AgentService'
import { UserService } from '@/services/UserService'
import { notify } from '@/mixins/notify'
import agentLogo from '../../assets/icons/agent-icon.png'

/**
 * Who collected the cash behind a cash transaction.
 *
 * The card used to be blank for these: the detail page had no case for `cash_transaction`,
 * so appliance down payments showed an empty panel whoever took the money. The creator is
 * polymorphic, so this resolves an agent or a web user accordingly.
 */
export default {
    name: 'CashTransactionDetail',
    mixins: [notify],
    props: ['ot'],
    data () {
        return {
            agentService: new AgentService(),
            userService: new UserService(),
            collector: {},
            agentLogo: agentLogo
        }
    },
    computed: {
        isAgent () {
            return this.ot && this.ot.creator_type === 'agent'
        }
    },
    mounted () {
        this.getCollector()
    },
    methods: {
        async getCollector () {
            try {
                if (this.isAgent) {
                    this.collector = await this.agentService.getAgent(this.ot.creator_id)
                    return
                }

                // Rows written before the polymorphic creator only carry user_id.
                const userId = (this.ot && this.ot.creator_id) || (this.ot && this.ot.user_id)
                if (!userId) return

                this.collector = await this.userService.get(userId)
            } catch (e) {
                this.alertNotify('error', e.message)
            }
        }
    }
}
</script>

<style scoped>
.n-font {
    font-weight: 100 !important;
}

.hr-d {
    height: 1pt;
    margin: auto;
    padding: 0;
    display: block;
    border: 0;
    background-color: rgba(0, 0, 0, 0.12);
}
</style>
